/** A cell of the board: its category's row and its day's column. */
export interface CellPosition {
  row: number
  col: number
}

/**
 * Where an arrow key, Home or End moves the focus on the board (W2-S S1: one
 * stop for the Tab key, the arrows inside). Only the days from `firstCol` on
 * can be changed, so only they take the focus: a day past is no stop. Null
 * when the key moves nothing (an edge, or a key that is not a move).
 */
export function nextCell(
  at: CellPosition,
  key: string,
  { rows, cols, firstCol }: { rows: number; cols: number; firstCol: number },
): CellPosition | null {
  if (rows <= 0 || firstCol >= cols) return null
  const to = (row: number, col: number) =>
    row === at.row && col === at.col ? null : { row, col: Math.max(firstCol, col) }
  switch (key) {
    case 'ArrowLeft':
      return at.col > firstCol ? to(at.row, at.col - 1) : null
    case 'ArrowRight':
      return at.col < cols - 1 ? to(at.row, at.col + 1) : null
    case 'ArrowUp':
      return at.row > 0 ? to(at.row - 1, at.col) : null
    case 'ArrowDown':
      return at.row < rows - 1 ? to(at.row + 1, at.col) : null
    case 'Home':
      return to(at.row, firstCol)
    case 'End':
      return to(at.row, cols - 1)
    default:
      return null
  }
}
